export const TRIM_HORIZONTAL_SPACING = 18;
export const TRIM_HEIGHT_DIMENSION_OFFSET = 2;
export const TRIM_WIDTH_DIMENSION_GAP = 2.5;
export const TRIM_STEP_DIMENSION_GAP = 1.5;
export const TRIM_DIMENSION_LABEL_GAP = 0.75;
export const TRIM_DIMENSION_LABEL_MARGIN = 0.4;
export const TRIM_DIMENSION_LABEL_HEIGHT_FACTOR = 1.2;
export const TRIM_NAME_GAP = 1.5;
export const TRIM_NAME_LINE_HEIGHT = 2.5;
export const TRIM_QTY_GAP = 3;

// the two halves are separate shapes only so they can differ in height; overlapping them at the
// centreline hides the antialiasing hairline SVG draws between abutting fills, without changing the outer 3"
export const TRIM_SEAM_OVERLAP = 0.0625;
